import { useEffect } from "react";
import type { AbstractAgent } from "@ag-ui/client";
import { invalidateAllSkillLists } from "~/services/skills";

const SKILL_TOOL_NAMES = new Set(["create_skill", "update_skill"]);

// SWR skill lists are only revalidated on manual edits; re-validate when the agent changes a skill.
export function useSkillSync(agent: AbstractAgent) {
  useEffect(() => {
    const sub = agent.subscribe({
      onToolCallEndEvent: ({ toolCallName }) => {
        if (SKILL_TOOL_NAMES.has(toolCallName)) {
          invalidateAllSkillLists().catch((err) =>
            console.error("[useSkillSync] Failed to refresh skills:", err)
          );
        }
      },
    });
    return () => sub.unsubscribe();
  }, [agent]);
}
